import React from 'react';
import Icon from './Icon';
import LoadingContainer from './LoadingContainer';
import PaymentMethodInfo from './PaymentMethodInfo';
import StripeCardForm from './StripeCardForm';
import StripeElementsWrapper from './StripeElementsWrapper';
import ConfirmationDialog from './ConfirmationDialog';
import { AuthContext } from './Layout';
import { unexpectedErrorFunction, postWithToken } from '../utils';
import { BASE_PATH } from '../config';

export default (props) => {
    const { 
        paymentMethods, 
        selectedPaymentMethod, 
        handlePaymentMethodCreated, 
        processPaymentRemoval, 
        stripeCustomerID, 
        selectedVerbiage="DEFAULT",
        handleSelectClick
    } = props;
    const [confirmationProps, setConfirmationProps] = React.useState({dialogOpen: false});
    const [formActive, setFormActive] = React.useState(false);
    const [updating, setUpdating] = React.useState(false);
    const user = React.useContext(AuthContext);
    function renderContent() {
        if (formActive) {
            return (
                <StripeElementsWrapper>
                    <StripeCardForm
                        stripeCustomerID={stripeCustomerID}
                        handlePaymentMethodCreated={paymentMethod => {handlePaymentMethodCreated(paymentMethod); setFormActive(false)}}
                        handleCancelClick={() => setFormActive(false)}
                    />
                </StripeElementsWrapper>
            )
        }
        return <button className='btn primary-outline-btn small-btn' onClick={() => setFormActive(true)}>ADD PAYMENT METHOD</button>
    }
    function handlePaymentRemoval(paymentMethodID) {
        setConfirmationProps({
            dialogOpen: true,
            handleConfirm: () => {
                setUpdating(true);
                setConfirmationProps({...confirmationProps, dialogOpen: false});
                const updatedPaymentMethods = paymentMethods.filter(item => item.id !== paymentMethodID);
                const defaultPaymentMethod = updatedPaymentMethods.length > 0 ? updatedPaymentMethods[0] : null;
                postWithToken(user.getIdToken(true), `${BASE_PATH}/detachPaymentMethod`, { paymentMethodID, defaultPaymentMethod })
                .then(({ data }) => {
                    processPaymentRemoval({
                        paymentMethods: updatedPaymentMethods,
                        defaultPaymentMethod: data.defaultPaymentMethod
                    });
                })
                .catch(unexpectedErrorFunction)
                .finally(() => {
                    setUpdating(false);
                    setConfirmationProps({ dialogOpen: false })
                })
            },
            handleCancel: () => setConfirmationProps({ dialogOpen: false }),
            header: "Delete Payment Method",
            message: "Are you sure you want to permanently delete this payment method?",
            btnText: "YES, DELETE",
            btnClass: "error-btn"
        })
    }
    return (
        <div>
            {paymentMethods && paymentMethods.length > 0 ?
            paymentMethods.map(paymentMethod => {
                const id = paymentMethod.id;
                const active = selectedPaymentMethod && id === selectedPaymentMethod.id;
                return (
                    <div className={`flex-action-container${active ? ' active' : ''}`} key={id}>
                        {active && <div className='default-banner'>{selectedVerbiage}</div>}
                        <button className='btn content' onClick={() => handleSelectClick(paymentMethod)}>
                            <PaymentMethodInfo paymentMethod={paymentMethod} />
                        </button>
                        <button className='btn action-btn' onClick={() => handlePaymentRemoval(id)} title="Delete this payment method">
                            <Icon iconName="times" width={16} />
                        </button>
                    </div>
                )
            })
            :
            <p>No payment methods to display</p>
            }
            <div className='add-margin-2'>
                {renderContent()}
            </div>
            {updating && <div className='updating-container'><LoadingContainer text="Please wait while we update your preferences..." /></div>}
            <ConfirmationDialog {...confirmationProps} />
        </div>
    )
}